import { ChevronUp, ChevronDown } from 'lucide-react';

export const SortableHeader = ({ 
    label, 
    sortKey, 
    currentSort, 
    currentDirection, 
    onSort,
    className = ''
}) => {
    const isActive = currentSort === sortKey;
    
    const handleClick = () => {
        if (isActive) {
            // Toggle direction
            onSort(sortKey, currentDirection === 'asc' ? 'desc' : 'asc');
        } else {
            // New sort key, default to ascending
            onSort(sortKey, 'asc');
        }
    };
    
    return (
        <th 
            className={`cursor-pointer select-none hover:bg-slate-100 transition-colors ${className}`}
            onClick={handleClick}
            data-testid={`sort-header-${sortKey}`}
        >
            <div className="flex items-center gap-1">
                <span>{label}</span>
                <div className="flex flex-col -space-y-1">
                    <ChevronUp 
                        className={`w-3.5 h-3.5 ${
                            isActive && currentDirection === 'asc' 
                                ? 'text-sky-600' 
                                : 'text-slate-300'
                        }`}
                    />
                    <ChevronDown 
                        className={`w-3.5 h-3.5 ${
                            isActive && currentDirection === 'desc' 
                                ? 'text-sky-600' 
                                : 'text-slate-300'
                        }`}
                    />
                </div>
            </div>
        </th>
    );
};

// Sorting utility function
export const sortData = (data, sortKey, direction) => {
    if (!sortKey || !data?.length) return data;
    
    return [...data].sort((a, b) => {
        let aVal = a[sortKey];
        let bVal = b[sortKey];
        
        // Handle null/undefined values
        if (aVal == null) aVal = '';
        if (bVal == null) bVal = '';
        
        // Handle numeric values
        if (typeof aVal === 'number' && typeof bVal === 'number') {
            return direction === 'asc' ? aVal - bVal : bVal - aVal;
        }
        
        // Handle date strings
        if (sortKey === 'created_at' || sortKey === 'timestamp' || sortKey === 'hora') {
            const dateA = new Date(aVal);
            const dateB = new Date(bVal);
            return direction === 'asc' ? dateA - dateB : dateB - dateA;
        }
        
        // Handle boolean (for confirmed status)
        if (typeof aVal === 'boolean') {
            return direction === 'asc' 
                ? (aVal === bVal ? 0 : aVal ? 1 : -1)
                : (aVal === bVal ? 0 : aVal ? -1 : 1);
        }
        
        // Handle strings
        const strA = String(aVal).toLowerCase();
        const strB = String(bVal).toLowerCase();
        
        if (direction === 'asc') {
            return strA.localeCompare(strB, 'es');
        } else {
            return strB.localeCompare(strA, 'es');
        }
    });
};

export default SortableHeader;
